import { createFeatureSelector, createSelector } from '@ngrx/store';
import { QueryResultsModel } from '../../_base/crud';
// State
import { RelationshipCategoryState } from '../_reducers/relationship-category.reducers';
import { RelationshipCategory } from '../_models/relationship-category.model';

export const selectRelationshipCategoryState =
  createFeatureSelector<RelationshipCategoryState>('RelationshipCategory');

export const selectRelationshipCategoryById = (relationshipCategoryId: number) =>
  createSelector(
    selectRelationshipCategoryState,
    (relationshipCategoryState) => relationshipCategoryState.entities[relationshipCategoryId],
  );

export const selectRelationshipCategoryPageLoading = createSelector(
  selectRelationshipCategoryState,
  (relationshipCategoryState) => {
    return relationshipCategoryState.listLoading;
  },
);

export const selectRelationshipCategoryActionLoading = createSelector(
  selectRelationshipCategoryState,
  (relationshipCategoryState) => relationshipCategoryState.actionsloading,
);

export const selectLastCreatedRelationshipCategoryId = createSelector(
  selectRelationshipCategoryState,
  (relationshipCategoryState) => relationshipCategoryState.lastCreatedRelationshipCategoryId,
);

export const selectLastCreatedRelationshipCategory = createSelector(
  selectRelationshipCategoryState,
  (relationshipCategoryState) => relationshipCategoryState.lastCreatedRelationshipCategory,
);

export const selectRelationshipCategoryPageLastQuery = createSelector(
  selectRelationshipCategoryState,
  (relationshipCategoryState) => relationshipCategoryState.lastQuery,
);
export const selectRelationshipCategoryError = createSelector(
  selectRelationshipCategoryState,
  (relationshipCategoryState) => relationshipCategoryState.error,
);
export const selectRelationshipCategoryLatestSuccessfullAction = createSelector(
  selectRelationshipCategoryState,
  (relationshipCategoryState) => relationshipCategoryState.latestSuccessfullAction,
);
export const selectRelationshipCategoryInStore = createSelector(
  selectRelationshipCategoryState,
  (relationshipCategoryState) => {
    const items = (relationshipCategoryState.ids as number[])
      .map((id) => relationshipCategoryState.entities[id])
      .filter((item): item is RelationshipCategory => item !== undefined);
    return new QueryResultsModel(items, relationshipCategoryState.totalCount);
  },
);

export const selectRelationshipCategoryShowInitWaitingMessage = createSelector(
  selectRelationshipCategoryState,
  (relationshipCategoryState) => relationshipCategoryState.showInitWaitingMessage,
);

export const selectHasRelationshipCategoryInStore = createSelector(
  selectRelationshipCategoryState,
  (queryResult) => {
    if (!queryResult.totalCount) {
      return false;
    }

    return true;
  },
);
